import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, MapPin } from "lucide-react";
import { IONA } from "@/constants/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="footer" className="bg-[#1A1A1A] text-white pt-20 pb-10">
      <div className="iona-container">
        <div className="grid md:grid-cols-12 gap-10 mb-14">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center overflow-hidden p-1.5">
                <img src={IONA.logo} alt="İONA" className="w-full h-full object-contain" />
              </div>
              <div>
                <div className="font-serif text-xl">İONA</div>
                <div className="text-[10px] tracking-[0.25em] text-[#B892D1] uppercase">
                  Ümraniye Güzellik Merkezi
                </div>
              </div>
            </div>
            <p className="text-white/60 leading-relaxed max-w-md text-sm">
              İONA - Ümraniye Güzellik Merkezi. Ümraniye'nin kalbinde, lazer
              epilasyon, cilt bakımı, saten yüz germe ve bölgesel incelme
              uygulamalarında premium güzellik deneyimi sunuyoruz.
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#B892D1] mb-5">
              Menü
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-white/80 hover:text-white">
                  Anasayfa
                </Link>
              </li>
              <li>
                <a href="/#hizmetler" className="text-white/80 hover:text-white">
                  Hizmetler
                </a>
              </li>
              <li>
                <a href="/#kampanyalar" className="text-white/80 hover:text-white">
                  Kampanyalar
                </a>
              </li>
              <li>
                <Link to="/blog" className="text-white/80 hover:text-white">
                  Blog
                </Link>
              </li>
              <li>
                <a href="/#iletisim" className="text-white/80 hover:text-white">
                  İletişim
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="text-xs uppercase tracking-[0.25em] text-[#B892D1] mb-5">
              İletişim
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3 text-white/80">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#B892D1]" />
                {IONA.location}
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <Phone className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#B892D1]" />
                <a href={`tel:${IONA.phoneIntl}`} className="hover:text-white">
                  {IONA.phone}
                </a>
              </li>
              <li className="flex items-start gap-3 text-white/80">
                <Instagram className="w-4 h-4 mt-0.5 flex-shrink-0 text-[#B892D1]" />
                <a
                  href={IONA.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white"
                >
                  @{IONA.instagram}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/50">
          <div>İONA - Ümraniye Güzellik Merkezi © {year}</div>
          <div className="flex gap-6">
            <Link to="/" className="hover:text-white">Anasayfa</Link>
            <a href="/#hizmetler" className="hover:text-white">Hizmetler</a>
            <a href="/#kampanyalar" className="hover:text-white">Kampanyalar</a>
            <a href="/#iletisim" className="hover:text-white">İletişim</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
